(ns ballot-scout-v2-frontend.exports.events
  (:require
   [ajax.edn :refer [edn-request-format edn-response-format]]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [re-frame.core :as rf]))

(defn- add-export-response-to-db
  [db ns-key response]
  (if (= (:response response) "No ballots found, so export cannot be created")
    (assoc-in db [ns-key :export :status] :empty-export)
    (assoc-in db [ns-key :export :status] :errored)))

(rf/reg-event-fx
 ::create-export-for-jurisdiction
 (fn [{:keys [db]} [_ ns-key url jurisdiction-id election-id query-params mimetype :as event-vec]]
   {:db (assoc-in db [ns-key :export] {:status :creating})
    ::events/ajax {:method :post
                   :url-params (merge {:election-id election-id} query-params)
                   :params {:mimetype mimetype}
                   :uri url
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::create-export-success
                                ns-key
                                event-vec
                                (partial urls/export-job-for-jurisdiction jurisdiction-id)]
                   :on-failure [::create-export-failure ns-key event-vec]}}))

(rf/reg-event-fx
 ::create-export-for-partner
 (fn [{:keys [db]} [_ ns-key url partner-id election-id query-params mimetype :as event-vec]]
   {:db (assoc-in db [ns-key :export] {:status :creating})
    ::events/ajax {:method :post
                   :url-params (merge {:election-id election-id} query-params)
                   :params {:mimetype mimetype}
                   :uri url
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::create-export-success
                                ns-key
                                event-vec
                                (partial urls/export-job-for-partner partner-id)]
                   :on-failure [::create-export-failure ns-key event-vec]}}))

(rf/reg-event-fx
 ::create-export-success
 (fn [{:keys [db]} [_ ns-key create-export-event-vec url-fn response]]
   {:db (-> db
            (assoc-in [ns-key :export :job] response)
            (assoc-in [ns-key :export :status] :generating))
    :dispatch [::request-helpers/clear-failed-request create-export-event-vec]
    :interval {:dispatch [::check-export-job ns-key (url-fn (:export-job/id response))]
               :action :start
               :ms 5000
               :id ::check-export-job}}))

(rf/reg-event-fx
 ::create-export-failure
 (fn [{:keys [db]} [_ ns-key event-vec response]]
   {:db (add-export-response-to-db db ns-key response)
    :dispatch [::request-helpers/request-failed event-vec response]}))

(rf/reg-event-fx
 ::check-export-job
 (fn [{:keys [db]} [_ ns-key export-url]]
   ;; don't check export job if a check is still ongoing
   (when (not= :fetching (get-in db [ns-key :export :job-status]))
     {:db (assoc-in db [ns-key :export :job-status] :fetching)
      ::events/ajax {:method :get
                     :uri export-url
                     :format (edn-request-format)
                     :response-format (edn-response-format)
                     :on-success [::check-export-job-success ns-key export-url]
                     :on-failure [::check-export-job-failure ns-key export-url]}})))

(rf/reg-event-fx
 ::check-export-job-success
 (fn [{:keys [db]} [_ ns-key export-url response]]
   (merge
    {:dispatch [::request-helpers/clear-failed-request [::check-export-job ns-key export-url]]}
    (if-not (= "completed" (:export-job/state response))
      {:db (assoc-in db [ns-key :export :job-status] :ready-to-fetch)}
      {:db (-> db
               (assoc-in [ns-key :export :link] (:export-job/url response))
               (assoc-in [ns-key :export :status] :ready)
               (assoc-in [ns-key :export :job-status] :ready-to-fetch))
       :interval {:id ::check-export-job :action :stop}}))))

(rf/reg-event-fx
 ::check-export-job-failure
 (fn [{:keys [db]} [_ ns-key export-url response]]
   {:dispatch [::request-helpers/request-failed [::check-export-job ns-key export-url] response]
    :db (-> db
            (assoc-in [ns-key :export :job-status] :ready-to-fetch)
            (add-export-response-to-db ns-key response))
    :interval {:id ::check-export-job :action :stop}}))

(rf/reg-event-fx
 ::clear-export-state
 (fn [{:keys [db]} [_ ns-key]]
   {:db (assoc-in db [ns-key :export] nil)
    :interval {:id ::check-export-job :action :stop}}))
